import React from 'react';
import styled from '@emotion/styled';
import { SettingButton } from 'components/views/atoms/SettingButton';

const Frame = styled.div({
    backgroundColor: '#279BE4',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '7px 15px',
});

type TitleProps = {
    clickable: boolean;
}

const Title = styled.span<TitleProps>(props => ({
    fontFamily: '\'Cabin Sketch\', arial, serif',
    textDecoration: 'none',
    color: 'white',
    fontSize: '15px',
    ':hover': props.clickable
        ? {
            color: '#23527c',
        }
        : {
        },
}));

export type WidgetHeaderProps = {
    title: string;
    onTitleClick?: () => void;
    onSettingButtonClick?: () => void;
}

export const WidgetHeader = (props: WidgetHeaderProps) => {
    const { title } = props;
    const onTitleClick = props.onTitleClick || (() => { /* nothing to do */ });
    const onSettingButtonClick = props.onSettingButtonClick || (() => { /* nothing to do */ });

    return (
        <Frame>
            <Title clickable={!!props.onTitleClick} onClick={onTitleClick}>{title}</Title>
            <SettingButton onClick={onSettingButtonClick} />
        </Frame>
    );
};
